<template>
  <div v-if="lastDocuments.length">
    <v-list subheader>
      <v-subheader >{{$t('DashboardPage.Documents.header')}}</v-subheader>
      <v-slide-y-transition group>
      
        <v-list-item v-for="(doc, index) in lastDocuments" :key="'document' + index" :href="getDocumentPath(doc.id)">
          <v-list-item-avatar>
            <v-icon large>picture_as_pdf</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="primary--text">{{doc.title}} </v-list-item-title>
            <v-list-item-subtitle>{{doc.category.title}}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action class="mr-4">
            <span class="font-weight-thin">{{doc.prettySize}}</span>
          </v-list-item-action>

          <v-list-item-action>
            <v-btn icon ripple :href="getDocumentPath(doc.id)">
              <v-icon large color="primary">get_app</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        
      </v-slide-y-transition>
    </v-list>
  </div>
</template>

<script>
import MeService from '@/services/me'
import prettyBytes from 'pretty-bytes'
import FilesathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  name: 'DocumentsList',
  mixins: [FilesathHelpersMixin],
  data () {
    return {
      publicPath: process.env.VUE_APP_SERVER_ADDRESS + '/files/documents/',
      documents: [],
      showMore: false
    }
  },
  computed: {
    lastDocuments () {
      return this.documents.slice(0, 4)
    }
  },
  async created () {
    const documents = await MeService.getPublicDocuments()
    this.documents = documents.map(doc => ({
      ...doc, 
      prettySize: prettyBytes(doc.fileSize),
    }))
  }
}
</script>

<style scoped>
#documents-list {
  background: none;
}
</style>
